





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { createCustomEvent } from '@/modules/CustomEvent'

@Component
export default class BookmarkInCard extends Vue {
  // ------------------------------------------------------------------------------------------------
  // prop
  @Prop() private urlPath!: string
  @Prop() private title!: string
  private loading = false
  private favoriteFlg = false

  // ------------------------------------------------------------------------------------------------
  // methods

  private created() {
    document.addEventListener('bookmark-update', this.updateBookmarkEvent)
  }

  private beforeDestroy() {
    document.removeEventListener('bookmark-update', this.updateBookmarkEvent)
  }

  /**
   * 状態の更新を行う
   */
  private updateBookmarkEvent(
    event: CustomEventInit<{ result: boolean; urlPath: string }>
  ) {
    if (event.detail !== undefined) {
      // URLが空、またはマッチする場合、状態を更新
      if (
        event.detail.urlPath == null ||
        event.detail.urlPath === this.urlPath
      ) {
        this.favoriteFlg = event.detail.result
        this.loading = false
      }
    }
  }

  /**
   * Bookmark登録
   */
  private async addBookmark() {
    this.loading = true

    createCustomEvent('bookmark-add', {
      urlPath: this.urlPath,
      title: this.title,
      callback: (result: boolean) => {
        if (result) {
          // ハートを有効にする
          this.favoriteFlg = true
        }
        this.loading = false
      }
    })
  }

  /**
   * ブックマーク削除
   */
  private async removeBookmark() {
    this.loading = true

    createCustomEvent('bookmark-remove', {
      urlPath: this.urlPath,
      callback: (result: boolean) => {
        if (result) {
          // ハートを無効にする
          this.favoriteFlg = false
        }
        this.loading = false
      }
    })
  }
}
